var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "time-grid-week",
      class: { eventDragged: _vm.eventDragged.eventId },
    },
    [
      _c(
        "div",
        { staticClass: "header-days" },
        _vm._l(_vm.dayLabels, function (day, index) {
          return _c("div", { key: day, staticClass: "day" }, [
            _c("label", { staticClass: "day-label" }, [
              _vm._v(_vm._s(day) + " " + _vm._s(_vm.weekDayNumbers[index])),
            ]),
            _c(
              "div",
              {
                staticClass: "count-event",
                class: { "no-content": !_vm.countEvent[index] },
              },
              [_vm._v(_vm._s(_vm.countEvent[index]))]
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "grid" }, [
        _c(
          "div",
          { staticClass: "scrollable-area" },
          _vm._l(24, function (hour, hourIndex) {
            return true ||
              _vm.eventsByTime.some((day) => day[hourIndex].length > 0)
              ? _c(
                  "div",
                  {
                    key: hour,
                    ref: "timeSlot",
                    refInFor: true,
                    staticClass: "time-slot",
                  },
                  [
                    _c("div", { staticClass: "time-label" }, [
                      _vm._v(_vm._s(String(hourIndex).padStart(2, "0")) + " h"),
                    ]),
                    _vm._l(7, function (dayNumber, dayIndex) {
                      return _c(
                        "div",
                        {
                          key: dayNumber,
                          staticClass: "cell-day",
                          class: {
                            today: _vm.datePassedInfo.dayIndex === dayIndex,
                            passed:
                              _vm.datePassedInfo.dayIndex > dayIndex ||
                              (_vm.datePassedInfo.dayIndex == dayIndex &&
                                _vm.datePassedInfo.hourIndex > hourIndex),
                          },
                          attrs: { id: `cell-${dayIndex}-${hourIndex}` },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return ((e) =>
                                _vm.selectDate(
                                  e,
                                  dayIndex + "-" + hourIndex + "-0"
                                )).apply(null, arguments)
                            },
                          },
                        },
                        _vm._l(6, function (slotNumber, index) {
                          return _c(
                            "div",
                            {
                              key: dayNumber + "-" + hourIndex + "-" + index,
                              staticClass: "slot",
                              class: {
                                empty:
                                  _vm.eventsByTime[dayIndex][hourIndex]
                                    .length == 0,
                              },
                              attrs: {
                                "drag-event-magnetic":
                                  _vm.datePassedInfo.dayIndex < dayIndex ||
                                  (_vm.datePassedInfo.dayIndex == dayIndex &&
                                    (_vm.datePassedInfo.hourIndex < hourIndex ||
                                      (_vm.datePassedInfo.hourIndex ==
                                        hourIndex &&
                                        _vm.datePassedInfo.slotIndex < index))),
                                "data-drag-event-hours": hourIndex,
                                "data-drag-event-minutes": index * 10,
                                "data-drag-event-location": `${dayIndex}-${hourIndex}-${index}`,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return ((e) =>
                                    _vm.selectDate(
                                      e,
                                      dayIndex + "-" + hourIndex + "-" + index
                                    )).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.eventsByTime[dayIndex][hourIndex].length >=
                              slotNumber
                                ? [
                                    slotNumber == 6 &&
                                    _vm.eventsByTime[dayIndex][hourIndex]
                                      .length > 6
                                      ? _c(
                                          "div",
                                          { staticClass: "container-btn-more" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "btn-more",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showMoreEvents(
                                                      dayIndex,
                                                      hourIndex
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.posts.planner.more-events",
                                                        {
                                                          count:
                                                            _vm.eventsByTime[
                                                              dayIndex
                                                            ][hourIndex]
                                                              .length - 5,
                                                        }
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "Event",
                                          _vm._b(
                                            {
                                              key: _vm.eventsByTime[dayIndex][
                                                hourIndex
                                              ][index].id,
                                              attrs: {
                                                isPlaceholder:
                                                  _vm.eventDragged.eventId ===
                                                  _vm.eventsByTime[dayIndex][
                                                    hourIndex
                                                  ][index].id,
                                                isDraggable:
                                                  _vm.eventsByTime[dayIndex][
                                                    hourIndex
                                                  ][index].editable !== false,
                                              },
                                              on: {
                                                eventDragStart:
                                                  _vm.eventDragStart,
                                                eventClick: function ($event) {
                                                  return _vm.$emit(
                                                    "eventClick",
                                                    _vm.eventsByTime[dayIndex][
                                                      hourIndex
                                                    ][index].id
                                                  )
                                                },
                                              },
                                            },
                                            "Event",
                                            _vm.eventsByTime[dayIndex][
                                              hourIndex
                                            ][index],
                                            false
                                          )
                                        ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    }),
                  ],
                  2
                )
              : _vm._e()
          }),
          0
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "btn-stacked-mode btn-radius",
          on: {
            click: function ($event) {
              return _vm.$emit("changeView", "dayGridWeek")
            },
          },
        },
        [
          _c("i", { staticClass: "fa-solid fa-angles-up" }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("dash.posts.planner.collapse")) +
              "\n    "
          ),
        ]
      ),
      _vm.popUpOptions.dayKey && _vm.popUpOptions.hourKey
        ? _c("EventsPopUp", {
            attrs: {
              eventDragged: _vm.eventDragged,
              events:
                _vm.eventsByTime[_vm.popUpOptions.dayKey][
                  _vm.popUpOptions.hourKey
                ],
              containerRef: _vm.$refs.container,
              anchorRef: _vm.popUpOptions.anchorRef,
              title: _vm.popUpOptions.dateLabel,
            },
            on: {
              close: _vm.closeMoreEvents,
              eventDragStart: _vm.eventDragStart,
              eventClick: (id) => _vm.$emit("eventClick", id),
            },
          })
        : _vm._e(),
      _c(
        "DraggableEvent",
        _vm._b(
          { on: { eventDragStop: _vm.eventDragStop } },
          "DraggableEvent",
          _vm.eventDragged,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }